import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "select"]

  connect() {
    this.options = Array.from(this.selectTarget.options)
  }

  filter() {
    const query = this.queryTarget.value.trim().toLowerCase()

    this.options.forEach((option) => {
      if (!option.value) return
      option.hidden = query.length > 0 && !option.text.toLowerCase().includes(query)
    })

    const selected = this.selectTarget.selectedOptions[0]
    if (selected?.hidden) this.selectTarget.value = ""
  }
}
